import request from '@/util/http'
import qs from 'qs'

// 获取全部标签列表
export const getAllLabelList=()=>request({
    url: '/admin/label/list',
    method: 'get'
})

// 获取标签信息
export const getLabelInfo=(id)=>request({
    url: `/admin/label/get/${id}`,
    method: 'get'
})

// 删除标签
export const handleDelLabel=(id)=>request({
    url: `/admin/label/delete/${id}`,
    method: 'delete'
})


// 移出
export const handleOut=(params)=>request({
    url: `/admin/label/out`,
    method: 'delete',
    // method: 'get',
    params
})


// 新增或编辑
export const handleSaveOrUpdate=(data)=>request({
    headers:{
        "Content-Type": "application/json"
    },
    url: '/admin/label/saveOrUpdate',
    method: 'post',
    data:JSON.stringify(data)
})

// 分页
export const gettLabelpage=(params)=>request({
    url: '/admin/label/page',
    method: 'get',
    params
})
// 获取标签信息
export const getStatInfo=(id)=>request({
    url: `/admin/label/stat/${id}`,
    method: 'get'
})

// 编辑
export const handleAddPost=(data)=>request({
    headers:{
        "Content-Type": "application/json"
    },
    url: '/admin/label/addPost',
    method: 'post',
    data:JSON.stringify(data)
})



// 添加人员
export const handleAddUser=(data)=>request({
    headers:{
        "Content-Type": "application/json"
    },
    url: '/admin/label/addUser',
    method: 'post',
    data:JSON.stringify(data)
})

